import React, { Fragment } from 'react';
import { Form, Input, message, Modal, Select } from 'antd';
import * as CommonService from '../../../../services/CommonService';
import { WARRANTY_POLICY } from '../../../../services/endpoint';

const { Option } = Select;

const AddWarrantyPolicy = (props) => {

	const { visible, setVisible, warrantyPolicyChange } = props;

	const [btnLoading, setBtnLoading] = React.useState(false);

	const { getFieldDecorator } = props.form;

	const afterOptions = () => {
		return getFieldDecorator('durationUnit', {
			initialValue: 'MONTH'
		})(
			<Select style={{ width: 80 }}>
				<Option value="DAY">Ngày</Option>
				<Option value="WEEK">Tuần</Option>
				<Option value="MONTH">Tháng</Option>
				<Option value="QUARTER">Quý</Option>
				<Option value="YEAR">Năm</Option>
			</Select>);
	};

	const handleAdd = (e) => {
		e.preventDefault();
		props.form.validateFields(async (err, values) => {
			if(!err) {
				setBtnLoading(true);
				CommonService.create(WARRANTY_POLICY, values).then(res => {
					setVisible(false);
					if (res.status === 200) {
						warrantyPolicyChange(res.data);
						props.form.resetFields();
					}
					message.success('Thêm thành công chính sách bảo hành');
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => setBtnLoading(false))
			}
		})
	}

	return <Fragment>
		<Modal
			title="Thêm chính sách bảo hành"
			visible={visible}
			onOk={handleAdd}
			confirmLoading={btnLoading}
			onCancel={() => {
				setVisible(false);
				props.form.resetFields();
			}}
		>
			<Form>
				<Form.Item label="Tên chính sách bảo hành" required={true}>
					{getFieldDecorator('name', {
						rules: [
							{
								required: true,
								message: 'Vui lòng nhập tên chính sách bảo hành'
							}
						]
					})(<Input placeholder={'Tên chính sách bảo hành'} />)}
				</Form.Item>
				<Form.Item label="Kỳ hạn bảo hành">
					{getFieldDecorator('duration', {
						initialValue: 1,
						rules: [
							{
								required: true,
								message: 'Vui lòng nhập kỳ hạn bảo hành'
							}
						]
					})(
						<Input type={'number'} min={1} addonAfter={afterOptions()} placeholder={'Nhập kỳ hạn bảo hành'} allowClear />
					)}
				</Form.Item>
			</Form>
		</Modal>
	</Fragment>;
};

export default Form.create({ name: 'AddWarrantyPolicy' })(AddWarrantyPolicy);
